import "./Descuento.css"
import { formatCurrency } from "src/shared/hooks/formatCurrency"
import { useFormatDate } from "src/shared/hooks/useFormatDate"

export interface DescuentoProps {
    monto: number
    fecha: Date
    nombre: string
    tipo: "Estancia" | "Extras"
}

const Descuento = ({ monto, fecha, nombre, tipo }: DescuentoProps) => {
    const { formatCustomDate } = useFormatDate()

    return (
        <div className="asignacion__reservaciones__drawer__tab-pay__header">
            <div className="asignacion__reservaciones__drawer__tab-pay__total">
                <span className="asignacion__reservaciones__drawer__tab-pay__total__label">
                    {`Descuento (${tipo})`}
                </span>
                <span className="asignacion__reservaciones__drawer__tab-pay__total__value">
                    {formatCustomDate(fecha, "MMM, DD YYYY")}
                </span>
            </div>
            <div className="asignacion__reservaciones__drawer__tab-pay__total">
                <span className="asignacion__reservaciones__drawer__tab-pay__card__label">
                    {nombre}
                </span>
                <span className="asignacion__reservaciones__drawer__tab-pay__card__value">
                    -{formatCurrency(monto)}
                </span>
            </div>
        </div>
    )
}

export default Descuento
